<template>
    <div class="lang" :style="{ width: width }">
      <a-select v-model="langCode" @change="onChange(langCode)" :placeholder="placeholder" :size="size">
        <a-select-option v-for="(item,index) in options"
                :key="index"
                :value="item.value" :title="language[item.langKey]">{{language[item.langKey]}}</a-select-option>

      </a-select>
    </div>
</template>

<script>
  import Vue from 'vue'
  import { mapActions } from 'vuex'
  import { USER_LANGUAGE } from "@/store/mutation-types"
  import {getAction,getFileAccessHttpUrl} from '@/api/manage';
  export default {
    name: 'JLanguageMenu',
    props: {
      placeholder:{
        type: String,
        default:'',
        required: false
      },
      size: {
        type: String,
        default:'default',
        required: false
      },
      width: {
        type: String,
        default:'auto',
        required: false
      }
    },
    data(){
      return {
        langCode: window.sessionStorage.getItem(USER_LANGUAGE) || 'zh_CN',
        options: [
          { value: 'zh_CN', text: '简体中文1' },
          { value: 'zh_TW', text: '繁體中文2' },
          { value: 'en_US', text: 'English3' }
        ]
      }
    },
    watch:{
      value (val) {}
    },
    created(){
      let that = this;
      // this.GetLanguage(Vue.ls.set(USER_LANGUAGE) || 'zh_CN');
     this.init(this.$store.getters.application.languageSettings);

    },
    computed: {
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      applicationChange(){
        let appCode = this.$store.getters.application.applicationCode
        // alert(this.$store.getters.application.applicationCode);
        let languageSettings = this.$store.getters.application.languageSettings;
        // this.init(languageSettings);
        getAction("/sys/dictItem/languageTemplate").then(res=>{
          if(res.success){
            let list = []
            if(languageSettings){
              let languages = languageSettings.split(",");
              languages.forEach(item=>{
                for(let i=0;i<res.result.length;i++){
                  if(item == res.result[i].value){
                    list.push(res.result[i]);
                    break
                  }
                }
              })
            }else{
              list = res.result
            }
            this.options = list
            let language = window.sessionStorage.getItem(USER_LANGUAGE);
            if(languageSettings){
              if(language&&languageSettings.indexOf(language)!=-1){
                this.langCode = language
              }else{
                this.langCode = list[0].value
                // this.onChange(this.langCode)
              }
            }else{
              this.langCode = language
            }
            console.log("----appCode--------",appCode);
            // this.GetLanguage(this.langCode+','+appCode)
            // this.GetLanguage(this.langCode)
            this.$store.commit('SET_LANGUAGELIST', list)
          }
        })
      },
      init(languageSettings){
        getAction("/sys/dictItem/languageTemplate",{dictCode:'system_language_template'}).then(res=>{
          if(res.success){
            let list = []
            if(languageSettings){
              res.result.forEach(item=>{
                if(languageSettings.indexOf(item.value)!=-1){
                  list.push(item);
                }
              })
            }else{
              list = res.result
            }
            this.options = list
            let language = window.sessionStorage.getItem(USER_LANGUAGE);
            if(languageSettings){
              if(language&&languageSettings.indexOf(language)!=-1){
                this.langCode = language
              }else{
                this.langCode = list[0].value
              }
            }else{
              this.langCode = language
            }
            this.$store.commit('SET_LANGUAGELIST', list)
            console.log("this.$store.getters.languagelist:",this.$store.getters.languagelist)
            console.log(this)
          }
        })
      },
      ...mapActions({
        GetLanguage: 'GetLanguage'
      }),
      onChange (selectedValue) {
        //window.sessionStorage.setItem('USER_LANGUAGE', selectedValue)
        this.GetLanguage(selectedValue)
        this.langCode = selectedValue
        this.$i18n.locale = selectedValue; //改变当前语言
        /*if(selectedValue==='zh_CN'){
          this.handleSetLanguage('zh-cn');
        }else if(selectedValue==='zh_TW'){
          this.handleSetLanguage('zh-tw');
        }else{
          this.handleSetLanguage('en-us');
        }*/

        // Vue.ls.set(USER_LANGUAGE, selectedValue, 7 * 24 * 60 * 60 * 1000);

        //window.location.href = ''
        this.$router.go(0);
        console.log(selectedValue)
      },
      handleSetLanguage(lang) {
        this.$i18n.locale = lang; //改变当前语言
        //Vue.ls.set("language", lang);//将lang 语言存在localStorage里，main里面就会根据属性值进行判断 locale: Vue.ls.get("language", "zh-CN")
      },
    }
  }
</script>

<style scoped>
  .lang{
    display: inline-block;
  }
</style>